import styled from 'styled-components';
import { Box, Button } from '@rsos/components/capstone/base';

export const ShareButtonContentWrapper = styled(Box).attrs({
  horizontal: true,
  flow: 5,
  align: 'center',
  justify: 'center',
  color: 'secondaryText',
})``;

export const ShareButton = styled(Button).attrs({
  btnType: 'invisible',
  color: 'secondaryText',
  size: 'xxsmall',
  noMargin: true,
  mr: 12,
  px: '6px',
  py: '0px',
})`
  &:focus {
    box-shadow: none;
  }
`;
